var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home_con_1"},[_c('img',{staticClass:"home_con_1_img",attrs:{"src":_vm.bannerImage}})]),_c('div',{staticClass:"home_con_2"},[_c('NewsList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }